import React from "react";
import { createUseStyles } from "react-jss";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";

const useStyles = createUseStyles((theme) => ({
	wrapper: {
		paddingBottom: "46px",
	},
	headerWrapper: {
		display: "flex",
		alignItems: "flex-start",
	},
	headerText: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		margin: 0,
		padding: 0,
		textTransform: "uppercase",
		position: "relative",
		"&:after": {
			content: "''",
			position: "absolute",
			height: "2px",
			width: "79px",
			bottom: "-9px",
			left: 0,
			backgroundColor: theme.palette.colors.purplishBlue,
		},
	},
}));

const DeclinationsOfferedInfo = (props) => {
	const { declinationsName, text } = props;
	const classes = useStyles();
	return (
		<Row>
			<Col xs={12} className={classes.wrapper}>
				<div className={classes.headerWrapper}>
					<div className={classes.headerText}>
						{text.recently_connected_tariffs}
						{declinationsName}
					</div>
				</div>
			</Col>
		</Row>
	);
};

export default DeclinationsOfferedInfo;
